import { createFileRoute } from "@tanstack/react-router";
import { PlatformSchedulerPage } from "@/components/platform-scheduler-page";
import { buildPageHead } from "@/lib/seo-meta";

const path = "/channels/facebook";

export const Route = createFileRoute(path)({
	component: FacebookScheduler,
	head: ({ matches }) =>
		buildPageHead({
			matches,
			internalPath: path,
			title: "AgentReacher | Connect your AI agent to Facebook",
			description:
				"Schedule Facebook page and group posts with an AI agent. Drafts, links, images, and timing handled. Cancel anytime.",
		}),
});

function FacebookScheduler() {
	return (
		<PlatformSchedulerPage
			platform="facebook"
			platformLabel="Facebook"
			hero={{
				title: "Connect your AI agent to Facebook",
				description:
					"Schedule Facebook page posts with an AI agent. Drafts, links, images, and audience-aware timing in one queue.",
			}}
		/>
	);
}
